var map = {
	"./": 41,
	"./App": 54,
	"./App.css": 101,
	"./App.js": 54,
	"./Pages": 28,
	"./Pages.js": 28,
	"./Utils": 6,
	"./Utils.js": 6,
	"./config/Config": 73,
	"./config/Config.js": 73,
	"./config/GearButton.css": 124,
	"./config/ModalMenu.css": 123,
	"./config/ajuda/Ajuda": 74,
	"./config/ajuda/Ajuda.css": 125,
	"./config/ajuda/Ajuda.js": 74,
	"./config/compartilhar/Compartilhar": 75,
	"./config/compartilhar/Compartilhar.css": 126,
	"./config/compartilhar/Compartilhar.js": 75,
	"./creditos/Creditos": 70,
	"./creditos/Creditos.css": 119,
	"./creditos/Creditos.js": 70,
	"./data/Causa": 59,
	"./data/Causa.js": 59,
	"./data/DataProvider": 57,
	"./data/DataProvider.js": 57,
	"./data/Geral": 58,
	"./data/Geral.js": 58,
	"./data/Prevencao": 63,
	"./data/Prevencao.js": 63,
	"./data/Sintomas": 62,
	"./data/Sintomas.js": 62,
	"./data/Transmissao": 61,
	"./data/Transmissao.js": 61,
	"./data/Untitled-1.css": 227,
	"./data/Vacinas": 60,
	"./data/Vacinas.js": 60,
	"./game/GamePage": 56,
	"./game/GamePage.js": 56,
	"./game/GameProvider": 26,
	"./game/GameProvider.js": 26,
	"./game/folder/Folder": 67,
	"./game/folder/Folder.css": 117,
	"./game/folder/Folder.js": 67,
	"./game/player/PlayerProvider": 17,
	"./game/player/PlayerProvider.js": 17,
	"./game/puzzle/ImageLoader": 39,
	"./game/puzzle/ImageLoader.js": 39,
	"./game/puzzle/Pieces": 29,
	"./game/puzzle/Pieces.js": 29,
	"./game/puzzle/Puzzle": 64,
	"./game/puzzle/Puzzle.css": 103,
	"./game/puzzle/Puzzle.js": 64,
	"./game/puzzle/modalWin/ModalWin": 65,
	"./game/puzzle/modalWin/ModalWin.css": 116,
	"./game/puzzle/modalWin/ModalWin.js": 65,
	"./game/puzzle/modalWin/warning/Warning": 66,
	"./game/puzzle/modalWin/warning/Warning.css": 115,
	"./game/puzzle/modalWin/warning/Warning.js": 66,
	"./game/score/Score": 68,
	"./game/score/Score.css": 118,
	"./game/score/Score.js": 68,
	"./game/timer/Timer": 69,
	"./game/timer/Timer.js": 69,
	"./globalProvider": 15,
	"./globalProvider.js": 15,
	"./index": 41,
	"./index.css": 127,
	"./index.js": 41,
	"./midias/images/eic/eic_og.png": 228,
	"./midias/images/eic/logo.png": 229,
	"./midias/images/games/puzzles/causa/1.png": 230,
	"./midias/images/games/puzzles/geral/1.png": 231,
	"./midias/images/games/puzzles/play.png": 232,
	"./midias/images/games/puzzles/prevencao/1.png": 233,
	"./midias/images/games/puzzles/sintomas/1.png": 234,
	"./midias/images/games/puzzles/transmissao/1.png": 235,
	"./midias/images/games/puzzles/vacinas/1.png": 236,
	"./midias/images/layout/puzzle.png": 237,
	"./modal/Modal": 22,
	"./modal/Modal.css": 114,
	"./modal/Modal.js": 22,
	"./music/Music": 76,
	"./music/Music.css": 128,
	"./music/Music.js": 76,
	"./puzzleMenu/PuzzleMenu": 55,
	"./puzzleMenu/PuzzleMenu.css": 102,
	"./puzzleMenu/PuzzleMenu.js": 55,
	"./rank/Rank": 71,
	"./rank/Rank.css": 122,
	"./rank/Rank.js": 71,
	"./rank/select/Select": 72,
	"./rank/select/Select.css": 121,
	"./rank/select/Select.js": 72,
	"./serviceWorker": 129,
	"./serviceWorker.js": 129,
	"./setupTests": 130,
	"./setupTests.js": 130,
	"./store/storeRanking": 27,
	"./store/storeRanking.js": 27,
	"./topMenu/TopMenu": 77,
	"./topMenu/TopMenu.css": 165,
	"./topMenu/TopMenu.js": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 100;